const texts = {
  ru: {
    stepOne: {
      title: 'Шаг 1',
      description: '<p>Размер системы - указываете количество событий, входящих в систему.</p><p>Кол-во ставок - количество исходов, из которых формируются экспрессы.</p>',
      field1: 'Кол-во ставок',
      field2: 'Размер системы',
      field3: 'Сумма ставки',
      field3Placeholder: 'Введите сумму',
      groupLabel: 'из',
      btnText: 'Продолжить',
      errorRequired: 'Заполните все поля',
      errorSize: 'Выбран неверный размер системы',
      errorMax: 'Выбран неверный размер системы',
      errorBet: 'Указана неверная сумма ставки',
      systemError: 'При выбраном размере системы количество вариантов превышает 1000',
    },
    stepTwo: {
      title: 'Шаг 2',
      description: '<p>Введите коэффициент событий и отметьте сыгранные:</p>',
      error: 'Один или несколько коэффициентов не указаны',
      steps: 'ставки сыграли',
      mark: 'Отметить все',
      remove: 'Убрать все',
      settle: 'Рассчитать',
      resettle: 'Пересчитать',
    },
    stepThree: {
      title: 'Шаг 3',
      description: '<p>В данной таблице представлены все варианты вашей системы:</p>',
      odds: 'Коэф.',
      stake: 'Ставка',
      win: 'Выигрыш',
      info: '* Красным цветом отмечены те коэффициенты, которые были исключены из расчета.',
      total: 'Общий выигрыш:',
      clear: 'Очистить все',
    },
    clearBtnText: 'Очистить',
  },

  uk: {
    stepOne: {
      title: 'Крок 1',
      description: '<p>Розмір системи - вказуєте кількість подій, що входять в систему.</p><p>Кількість ставок - кількість результатів, з яких формуються експреси.</p>',
      field1: 'К-сть ставок',
      field2: 'Розмір системи',
      field3: 'Сума ставки',
      field3Placeholder: 'Введіть суму',
      groupLabel: 'з',
      btnText: 'Продовжити',
      errorRequired: 'Заповніть всі поля',
      errorSize: 'Вибрано невірний розмір системи',
      errorMax: 'Вибрано невірний розмір системи',
      errorBet: 'Вказана невірна сума ставки',
      systemError: 'При вибраному розмірі системи кількість варіантів перевищує 1000',
    },
    stepTwo: {
      title: 'Крок 2',
      description: '<p>Введіть коефіцієнт подій і позначте зіграні:</p>',
      error: 'Один або декілька коефіцієнтів не вказані',
      steps: 'ставки зіграли',
      mark: 'Позначити всі',
      remove: 'Прибрати все',
      settle: 'Розрахувати',
      resettle: 'Перерахувати',
    },
    stepThree: {
      title: 'Крок 3',
      description: '<p>В цій таблиці представлені всі варіанти вашої системи:</p>',
      odds: 'Коеф.',
      stake: 'Ставка',
      win: 'Виграш',
      info: '* Червоним кольором позначені ті коефіцієнти, які були виключені з розрахунку.',
      total: 'Загальний виграш:',
      clear: 'Очистити все',
    },
    clearBtnText: 'Очистити',
  },

  en: {
    stepOne: {
      title: 'Step 1',
      description: '<p>The System size - enter the number of events, which the system includes.</p><p>The number of bets - the number of outcomes that are included the Parlay.</p>',
      field1: 'Number of bets',
      field2: 'System size',
      field3: 'Stake amount',
      field3Placeholder: 'Enter amount',
      groupLabel: 'of',
      btnText: 'Continue',
      errorRequired: 'Please fill in all the fields',
      errorSize: 'Invalid system size',
      errorMax: 'Invalid system size',
      errorBet: 'Invalid stake amount',
      systemError: 'There are more than 1000 options with the selected system size',
    },
    stepTwo: {
      title: 'Step 2',
      description: '<p>Enter the odds of events and mark the winning ones:</p>',
      error: 'One or more odds are not entered',
      steps: 'system bet won',
      mark: 'Mark all',
      remove: 'Clear all',
      settle: 'Calculate',
      resettle: 'Calculate again',
    },
    stepThree: {
      title: 'Step 3',
      description: '<p>This table shows all the options for your System:</p>',
      odds: 'Odds',
      stake: 'Stake',
      win: 'Win',
      info: '* Odds excluded from the calculation are marked in red.',
      total: 'Total win:',
      clear: 'Clear all',
    },
    clearBtnText: 'Clear',
  }
};

export default texts;
